module.exports = __webpack_public_path__ + "static/agency_1-1e2c64b13bebc3f3bb849f70cdf749ac.svg";